import Config from '../config'
import Ajax from './ajax'


var AlbelliApi = {};

/**
 * ASYNC function
 *
 * This function fetches channel data from an API
 * The channel data is for example vendor, language, currency used and such for a given site (channel)
 * @param  {string}
 * @return {Promise}
 */
AlbelliApi.getChannelData = function (channel) {
	return new Promise(function (resolve, reject) {
		Ajax.get({
			url: Config.CurrencyApi + '/?format=xml&expanded=false&channel=' + channel,
			responseType: 'XML'
		}).then(function (xml) {
			resolve(AlbelliApi._createChannelObject(xml));
		}).catch(function (error) {
			reject({message: "Unable to initial channel data. Please try again later. If the problem persists, please contact customer service and give them the details about the error.", details: "Cannot get channel data for channel " + channel + ". Url: " + Config.CurrencyApi + '/?expanded=false&format=xml&channel=' + channel, error: error});
		});
	});
};

AlbelliApi._createChannelObject = function (xml) {

	//Validate
	if (!xml.childNodes) {
		throw new Error("Tried to open channel xml but the document seems invalid");
	}

	var channel = xml.childNodes[0];
	var data = {};

	//Validate
	if (channel.getElementsByTagName("vendor").length == 0) {
		throw new Error("Tried to fetch vendor tag from channel xml but it was not in the document");
	}

	if (channel.getElementsByTagName("currency").length == 0) {
		throw new Error("The channel xml is missing the currency tag. XML: " + xml);
	}

	if (channel.getElementsByTagName("priceFormat").length == 0) {
		throw new Error("The channel xml is missing the priceFormat tag. XML: " + xml);
	}

	//Collect data
	data.vendor = channel.getElementsByTagName("vendor")[0].getAttribute("id");
	data.language = channel.getElementsByTagName("vendor")[0].getAttribute("locale");
	data.currency = {};

	data.currency.symbol = channel.getElementsByTagName("currency")[0].getElementsByTagName("symbol")[0].childNodes[0].nodeValue;
	data.currency.code = channel.getElementsByTagName("currency")[0].getAttribute("id");
	data.currency.decimalSeparator = channel.getElementsByTagName("priceFormat")[0].getElementsByTagName("decimalSeparator")[0].childNodes[0].nodeValue;
	data.currency.thousandsSeparator = channel.getElementsByTagName("priceFormat")[0].getElementsByTagName("thousandsSeparator")[0].childNodes[0].nodeValue;
	data.currency.showSymbol = channel.getElementsByTagName("priceFormat")[0].getElementsByTagName("showSymbol")[0].childNodes[0].nodeValue === "true";
	if (channel.getElementsByTagName("priceFormat")[0].getElementsByTagName("zeroDecimalsReplacement").length > 0) {
		if (channel.getElementsByTagName("priceFormat")[0].getElementsByTagName("zeroDecimalsReplacement")[0].childNodes.length > 0) {
			data.currency.zeroDecimalsReplacement = channel.getElementsByTagName("priceFormat")[0].getElementsByTagName("zeroDecimalsReplacement")[0].childNodes[0].nodeValue;
		}
	}

	return data;
};

export default AlbelliApi;
